import { render } from "./MyRegister.vue?vue&type=template&id=e8cf0a4a"
import script from "./MyRegister.vue?vue&type=script&lang=js"
export * from "./MyRegister.vue?vue&type=script&lang=js"

import "./MyRegister.vue?vue&type=style&index=0&id=e8cf0a4a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__